import CONST from '../constants';
import APPLICATION_TYPE from '../constants/application-type';
import moment from 'moment';

const withTax = (price, tax, count = 1) => Math.floor((price * (tax + 100)) / 100) * Number(count);

const getRevenueStampPrice = (certPeriod, feeRate, entriedAt = new Date()) => {
  // NOTE: 発行手数料の料金改定に伴い、2021年3月30日から新料金での提供をするためここで分岐を行っている
  const certPeriods = moment(entriedAt).isAfter(moment("20210330", "YYYYMMDD")) ? CONST.MASTER.CERT_PERIOD : CONST.MASTER.OLD_CERT_PERIOD;
  const target = certPeriods.find(p => p.period === Number(certPeriod));
  return Math.floor((target.price * (feeRate + 100)) / 100);
};

const getTotalPrice = (priceTable, formData) => {
  if (!priceTable || !formData) {
    return 0;
  }
  const planPrice = formData.applicationType === APPLICATION_TYPE.CODE.WINDOW ? priceTable.price : priceTable.deliveryPrice;
  const revenueStampPrice = formData.isWithRevenueStamp ? getRevenueStampPrice(formData.certPeriod, priceTable.revenueStampFeeRate) : 0;
  return withTax(planPrice, priceTable.tax) + withTax(revenueStampPrice, priceTable.tax);
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { withTax, getRevenueStampPrice, getTotalPrice };
